export function isCtrlClick(event: React.MouseEvent<HTMLAnchorElement>) {
  return event.ctrlKey || event.metaKey;
}
